import { HStack, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore } from "@src/utils/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { getQueryParamOptional } from "@src/utils/routing";
import { useRouter } from "next/router";
import type { Route } from "nextjs-routes";
import type { FC } from "react";
import { NavBar } from "./NavBar";

export const BACK_BUTTON_QUERY_PARAM_KEY = "go_back_to";

type BackButtonProps = {
  defaultUrl: Route["pathname"];
  allowedUrls?: Route["pathname"][];
};
export const BackButton: FC<BackButtonProps> = ({
  defaultUrl,
  allowedUrls = [],
}) => {
  const { UIStore } = useStore();
  const router = useRouter();
  const { isMobile } = useScreenType();
  const goBack = async () => {
    const goBackTo = getQueryParamOptional(
      BACK_BUTTON_QUERY_PARAM_KEY,
      router.query,
    ) as Route["pathname"] | undefined;
    if (goBackTo) {
      router.replace(goBackTo);
      return;
    }
    const storage = globalThis?.sessionStorage;
    const prevPath = storage.getItem("prevPath");

    /**
     * Automatically include defaultUrl to allowedUrls to persist query params when going back
     */
    const allowedUrlsIncludingDefaultUrl = [...allowedUrls, defaultUrl];

    await UIStore.onBackButtonClick?.();

    !!prevPath &&
    allowedUrlsIncludingDefaultUrl.includes(prevPath as Route["pathname"])
      ? router.back()
      : router.push(defaultUrl);
  };

  return (
    <NavBar.Item active={false} onClick={goBack}>
      <HStack>
        <Icon name="chevron-left" w="5" h="5" color="grey.500" />
        {!isMobile && (
          <Text fontWeight="semibold">
            <Trans>Back</Trans>
          </Text>
        )}
      </HStack>
    </NavBar.Item>
  );
};
